'use client';

import _defineProperty from "/codebuild/output/src1286/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { rem } from '../../core/utils/units-converters/rem.mjs';
import 'react';
import 'react/jsx-runtime';
import '@mantine/hooks';
import 'clsx';
import '../../core/MantineProvider/Mantine.context.mjs';
import '../../core/MantineProvider/default-theme.mjs';
import '../../core/MantineProvider/MantineProvider.mjs';
import '../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import '../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import '../../core/Box/Box.mjs';
import '../../core/DirectionProvider/DirectionProvider.mjs';
var popIn = function popIn(from) {
  return {
    "in": {
      opacity: 1,
      transform: "scale(1)"
    },
    out: {
      opacity: 0,
      transform: "scale(.9) translateY(".concat(rem(from === "bottom" ? 10 : -10), ")")
    },
    transitionProperty: "transform, opacity"
  };
};
var transitions = {
  fade: {
    "in": {
      opacity: 1
    },
    out: {
      opacity: 0
    },
    transitionProperty: "opacity"
  },
  "fade-up": {
    "in": {
      opacity: 1,
      transform: "translateY(0)"
    },
    out: {
      opacity: 0,
      transform: "translateY(".concat(rem(30))
    },
    transitionProperty: "opacity, transform"
  },
  "fade-down": {
    "in": {
      opacity: 1,
      transform: "translateY(0)"
    },
    out: {
      opacity: 0,
      transform: "translateY(".concat(rem(-30))
    },
    transitionProperty: "opacity, transform"
  },
  "fade-left": {
    "in": {
      opacity: 1,
      transform: "translateX(0)"
    },
    out: {
      opacity: 0,
      transform: "translateX(".concat(rem(30))
    },
    transitionProperty: "opacity, transform"
  },
  "fade-right": {
    "in": {
      opacity: 1,
      transform: "translateX(0)"
    },
    out: {
      opacity: 0,
      transform: "translateX(".concat(rem(-30))
    },
    transitionProperty: "opacity, transform"
  },
  scale: {
    "in": {
      opacity: 1,
      transform: "scale(1)"
    },
    out: {
      opacity: 0,
      transform: "scale(0)"
    },
    common: {
      transformOrigin: "top"
    },
    transitionProperty: "transform, opacity"
  },
  "scale-y": {
    "in": {
      opacity: 1,
      transform: "scaleY(1)"
    },
    out: {
      opacity: 0,
      transform: "scaleY(0)"
    },
    common: {
      transformOrigin: "top"
    },
    transitionProperty: "transform, opacity"
  },
  "scale-x": {
    "in": {
      opacity: 1,
      transform: "scaleX(1)"
    },
    out: {
      opacity: 0,
      transform: "scaleX(0)"
    },
    common: {
      transformOrigin: "left"
    },
    transitionProperty: "transform, opacity"
  },
  "skew-up": {
    "in": {
      opacity: 1,
      transform: "translateY(0) skew(0deg, 0deg)"
    },
    out: {
      opacity: 0,
      transform: "translateY(".concat(rem(-20), ") skew(-10deg, -5deg)")
    },
    common: {
      transformOrigin: "top"
    },
    transitionProperty: "transform, opacity"
  },
  "skew-down": {
    "in": {
      opacity: 1,
      transform: "translateY(0) skew(0deg, 0deg)"
    },
    out: {
      opacity: 0,
      transform: "translateY(".concat(rem(20), ") skew(-10deg, -5deg)")
    },
    common: {
      transformOrigin: "bottom"
    },
    transitionProperty: "transform, opacity"
  },
  "rotate-left": {
    "in": {
      opacity: 1,
      transform: "translateY(0) rotate(0deg)"
    },
    out: {
      opacity: 0,
      transform: "translateY(".concat(rem(20), ") rotate(-5deg)")
    },
    common: {
      transformOrigin: "bottom"
    },
    transitionProperty: "transform, opacity"
  },
  "rotate-right": {
    "in": {
      opacity: 1,
      transform: "translateY(0) rotate(0deg)"
    },
    out: {
      opacity: 0,
      transform: "translateY(".concat(rem(20), ") rotate(5deg)")
    },
    common: {
      transformOrigin: "top"
    },
    transitionProperty: "transform, opacity"
  },
  "slide-down": {
    "in": {
      opacity: 1,
      transform: "translateY(0)"
    },
    out: {
      opacity: 0,
      transform: "translateY(-100%)"
    },
    common: {
      transformOrigin: "top"
    },
    transitionProperty: "transform, opacity"
  },
  "slide-up": {
    "in": {
      opacity: 1,
      transform: "translateY(0)"
    },
    out: {
      opacity: 0,
      transform: "translateY(100%)"
    },
    common: {
      transformOrigin: "bottom"
    },
    transitionProperty: "transform, opacity"
  },
  "slide-left": {
    "in": {
      opacity: 1,
      transform: "translateX(0)"
    },
    out: {
      opacity: 0,
      transform: "translateX(100%)"
    },
    common: {
      transformOrigin: "left"
    },
    transitionProperty: "transform, opacity"
  },
  "slide-right": {
    "in": {
      opacity: 1,
      transform: "translateX(0)"
    },
    out: {
      opacity: 0,
      transform: "translateX(-100%)"
    },
    common: {
      transformOrigin: "right"
    },
    transitionProperty: "transform, opacity"
  },
  pop: _objectSpread(_objectSpread({}, popIn("bottom")), {}, {
    common: {
      transformOrigin: "center center"
    }
  }),
  "pop-bottom-left": _objectSpread(_objectSpread({}, popIn("bottom")), {}, {
    common: {
      transformOrigin: "bottom left"
    }
  }),
  "pop-bottom-right": _objectSpread(_objectSpread({}, popIn("bottom")), {}, {
    common: {
      transformOrigin: "bottom right"
    }
  }),
  "pop-top-left": _objectSpread(_objectSpread({}, popIn("top")), {}, {
    common: {
      transformOrigin: "top left"
    }
  }),
  "pop-top-right": _objectSpread(_objectSpread({}, popIn("top")), {}, {
    common: {
      transformOrigin: "top right"
    }
  })
};
export { transitions };